module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjIuNzUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTMgNi4yaDE4TTMgMTJoMThNMyAxOGgxOCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/icons/hamburger.svg
// module id = 1755
// module chunks = 1